import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './PostLikesList.css';
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { SocialUserAvatar } from "./SocialUserAvatar";
import { SocialUserName } from "./SocialUserName";
import { FaTimes, FaSpinner } from 'react-icons/fa';

const PostLikesList = ({ postId, isOpen, onClose }) => {
  const [likes, setLikes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const modalRef = useRef(null);

  useEffect(() => {
    const fetchLikes = async () => {
      if (!postId || !isOpen) return;
      
      setLoading(true);
      try {
        const response = await sdk.models.PostsLike.getPostLikes({ post_id: postId });
        setLikes(response.likes || []);
        setError(null);
      } catch (err) {
        console.error("Erreur lors de la récupération des likes:", err);
        setError("Impossible de charger les personnes qui ont aimé ce post");
      } finally {
        setLoading(false);
      }
    };

    fetchLikes();
  }, [postId, isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscapeKey);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="pll-overlay">
      <div className="pll-modal" ref={modalRef}>
        <div className="pll-modal-header">
          <h3 className="pll-modal-title">Personnes qui ont aimé</h3>
          <button 
            type="button" 
            className="pll-close-button" 
            onClick={onClose} 
            aria-label="Fermer"
          >
            <FaTimes />
          </button>
        </div>
        
        <div className="pll-modal-body">
          {loading ? (
            <div className="pll-loading">
              <FaSpinner className="pll-spinner" />
              <span>Chargement...</span>
            </div>
          ) : error ? (
            <div className="pll-error">{error}</div>
          ) : likes.length === 0 ? (
            <div className="pll-empty">Personne n'a encore aimé ce post</div>
          ) : (
            <ul className="pll-likes-list">
              {likes.map((like) => (
                <li key={like.id} className="pll-likes-item">
                  <div className="pll-user-avatar">
                    <SocialUserAvatar user_id={like.user_id} />
                  </div>
                  <div className="pll-user-name">
                    <SocialUserName user_id={like.user_id} />
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export { PostLikesList };
export default PostLikesList;